// extracted by mini-css-extract-plugin
export default {"card":"s1-z","carouselContainer":"t1-z","carouselContent":"u1-z"};